import React from 'react';
import webapi from '../../../api/webapi';
import LoadingGif from '../../images/loading.gif';


export default class SurfResultImageListImage extends React.Component {
    state = { Image: '' };

    componentDidUpdate() {
        this.getPage();
    }

    async getPage() {
        if (this.props.picTurn === this.props.picLoadingQueue)
        {
            const ImageConst = await webapi.get('book/bookversiongetpic/'+this.props.imageCode);
            this.setState({
                Image: ImageConst.data[0].Picture
            },()=>{});

            if (ImageConst.data[0].Picture)
                this.props.nextPicLoadingStart();
        }
    }

    render() {
        return (
            (this.state.Image)
            ?
                [                    
                    <div style={{float:"left",backgroundColor:"transparent", position: "relative"}} key={'SRILI1'}>
                        <img alt="a" className="bookpage_img"
                            // className={this.props.Class} 
                            src= {"data:image/png;base64,"+this.state.Image} 
                            style={{width:"100%",height:"auto",zIndex:"-1"}}
                        />
                        <div style={{position:"absolute",left:"61px", top:"64px", fontSize:"50px", zIndex:"1"}}>
                            {/* {this.props.picTurn+1} */}
                            <a href="/#" name={"Page"+(this.props.picTurn+1)}> </a>
                        </div>
                    </div>
                ]
            :
                <div style={{width:"100%",paddingTop: "130%",border:"1px",borderColor:"gray",backgroundColor:"white",textAlign:"center",verticalAlign:"center",display:"inline-block",borderStyle:"solid",zIndex:"-1"}}  key={'SRILI2'}>
                    <img className="loading_img" alt='loading...' src={LoadingGif} />
                    <div style={{position:"relative",top:"20%", fontSize:"50px", zIndex:"1",margin: "auto"}}>
                            {this.props.picTurn+1}
                            <a href="/#" name={"Page"+(this.props.picTurn+1)}> </a>
                        </div>
                </div>
        )
    }
}